/* eslint-disable */
import { API_URL } from 'config';
import { store } from 'store.js';
import { caricamento, aggiornaBi } from 'features/bi/biSlice';
import axios from 'axios';
import _ from 'lodash';

const API_BI_URL = `${API_URL}/bi/get_bi/`;
const API_BI_CLIENTE_URL = `${API_URL}/bi/get_bi/cliente/`;
const API_BI_ARTICOLO_URL = `${API_URL}/bi/get_bi/articolo/`;

export const getDataCliente = async () => {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_BI_CLIENTE_URL, { utente, pin });
    const { successo = false, bi = [] } = res.data;
    if (!successo) throw new Error(JSON.stringify(res));

    const coseBelle = []

    Object.keys(bi).forEach((cliente) => {
      const perAnno = _.groupBy(bi[cliente], 'Anno');
      const anni = {} 
      Object.keys(perAnno).map((anno) => {
        anni[anno] = `kg. ${_.sumBy(perAnno[anno], 'Volumi').toFixed(2)}`
      })

      coseBelle.push({cliente: cliente, ...anni})
    })
console.log(coseBelle[0])
    store.dispatch(aggiornaBi(coseBelle)) 

    store.dispatch(caricamento(false));
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('Unable to load bi data');
    console.log('errore', e);
  }
};

export const getData = async () => {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
    bi: {
      calendario
    }
  } = store.getState();

  try {
        const res = await axios.post(API_BI_URL, { utente, pin, data: calendario });
    const { successo = false, bi = [] } = res.data;
    if (!successo) throw new Error(JSON.stringify(res));

     const italia = [...bi.filter(a => a?.Zona === 'Italia')]
    const estero = [...bi.filter(a => a?.Zona === 'Other')]
    const totali = [...bi.filter(a => a?.Zona === null)]

    const biFilter = {
      coseanoItalia: italia.find(a => a?.Stabilimento === 'Coseano'),
      coseanoEstero: estero.find(a => a?.Stabilimento === 'Coseano'),
      coseanoTotale: totali.find(a => a?.Stabilimento === 'Coseano'),
      modugnoItalia: italia.find(a => a?.Stabilimento === 'Modugno'),
      modugnoEstero: estero.find(a => a?.Stabilimento === 'Modugno'),
      modugnoTotale: totali.find(a => a?.Stabilimento === 'Modugno'),
      totaleItalia:  italia.find(a => a?.StabilimentoNum === 99),
      totaleEstero:  estero.find(a => a?.StabilimentoNum === 99),
    }

    store.dispatch(aggiornaBi(biFilter)) 
    store.dispatch(caricamento(false));
 } catch (e) {
    // eslint-disable-next-line no-alert
    alert('Unable to load bi data');
    console.log('errore', e);
  }
};
